import React from 'react';
import injectSheet from 'react-jss';

import { Col } from 'antd';
import FormContact from './components/FormContact';
import Location from './components/Location';

const styles = () => ({
  root: {
    color: '#FFFFFF',
    width: '100%',
    padding: '3em 0 0 0',
  },
});

const Contact = (props) => {
  const { classes } = props;

  return (
    <Col className={classes.root} span={18}>
      <FormContact />
      <Location />
    </Col>
  );
};

export default injectSheet(styles)(Contact);



// WEBPACK FOOTER //
// ./src/app/pages/contact/index.jsx